import styled from "styled-components";

export const OrganizationListWrapper = styled.div`
    height: 100%;
`